import { render, staticRenderFns } from "./ClubModules.vue?vue&type=template&id=39c4e1d0"
import script from "./ClubModules.vue?vue&type=script&lang=js"
export * from "./ClubModules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports